import { Col, Image, Row } from 'react-bootstrap';
import { formatMoneyShorthand } from 'utils/formatMoney';
import { useDrag } from 'react-dnd';
import DefaultAvatar from 'components/global/DefaultAvatar';
import { $view } from 'signals/global.signals';
import InvestorDealflowContextMenu from 'components/views/InvestorDealflow/_components/InvestorDealflowItemContextMenu';

const InvestorDealflowListItem = ({ dealflowItem }) => {
  // Access the signal value to create a subscription
  const { isDragDisabled } = $view.value;

  const [{ isDragging }, drag] = useDrag(() => ({
    type: 'investor',
    item: { dealflowItem },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  }), [dealflowItem]);

  // Add defensive check after hooks to prevent hook inconsistencies
  if (!dealflowItem) {
    return null;
  }

  return (
    <div
      ref={isDragDisabled ? null : drag}
      style={{
        opacity: isDragging ? 0.5 : 1,
        cursor: isDragDisabled ? 'default' : 'move',
      }}
      className="position-relative bg-gray-800 border border-gray-700 rounded px-32"
    >
      <Row className="align-items-center pb-16">
        <Col className="d-flex align-items-center" sm={1}>
          <div
            className="d-flex justify-content-center rounded-circle flex-shrink-0 profileSettingsAvatar mb-md-0 my-16"
            style={{ width: '40px', height: '40px' }}
          >
            {dealflowItem.companyLogo
              ? <Image src={dealflowItem.companyLogo} style={{ objectFit: 'cover' }} />
              : (
                <DefaultAvatar
                  name={dealflowItem.companyName}
                  image={dealflowItem.companyLogo}
                  size="md"
                />
              )}
          </div>
        </Col>
        <Col sm={3}>
          <div><small className="text-gray-400">Organization</small></div>
          {dealflowItem.companyName}
        </Col>
        <Col sm={3}>
          <div><small className="text-gray-400">Deal Name</small></div>
          {dealflowItem.name
            ? (<span>{dealflowItem.name}</span>)
            : (<span className="text-gray-400">N/A</span>)}
        </Col>
        <Col>
          <div><small className="text-gray-400">Valuation</small></div>
          {formatMoneyShorthand(dealflowItem.currentValue)}
        </Col>
        <Col>
          <div><small className="text-gray-400">Committed</small></div>
          {formatMoneyShorthand(dealflowItem.previouslyCommitted)}
        </Col>
        <Col>
          <div><small className="text-gray-400">Deal ID</small></div>
          {dealflowItem.dealId}
        </Col>
        <Col className="d-flex justify-content-end mt-16">
          <InvestorDealflowContextMenu dealflowItem={dealflowItem} />
        </Col>
      </Row>
    </div>
  );
};

export default InvestorDealflowListItem;
